import type { ScopeRegistry } from './interfaces'

// The sources read entity and page stores, which shared cannot import: the app layer registers them at start.
let registry: ScopeRegistry | null = null

export const registerScope = (value: ScopeRegistry): void => {
  registry = value
}

export const getScopeRegistry = (): ScopeRegistry => {
  if (!registry) throw new Error('The scope registry is empty: app/plugins/scope-registry.client.ts registers it at start')

  return registry
}
